import { useState } from 'react';
import { Link } from 'react-scroll';
import logo from '../../images/parkandflylogo.png';
import "./NavBar.scss";

const NavBar = () => {
  const [isNavOpen, setNavOpen] = useState(false);

  const toggleMenu = () => setNavOpen(prev => !prev);
  const handleLinkClick = () => setNavOpen(false);

  return (
    <nav>
      <div className="nav-container">
        <Link to="reservation" className="logo" smooth duration={1000}>
          <img loading="lazy" src={logo} alt="logo" />
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          <span className={`nav-icon ${isNavOpen ? "open" : ""}`} />
        </div>

        <ul className={`menu ${isNavOpen ? "open" : ""}`}>
          <li><Link to="how-to-find-section" smooth duration={1000} onClick={handleLinkClick}>Kaip mus rasti?</Link></li>
          <li><Link to="howtouse" smooth duration={1000} onClick={handleLinkClick}>Kaip naudotis?</Link></li>
          <li><Link to="reservation" smooth duration={1000} onClick={handleLinkClick}>Rezervacija</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
